export function turnoAcompanhamentosInRequest(params = {}) {
  return {
    type: '@turnoacompanhamento/TURNOACOMPANHAMENTO_IN_REQUEST',
    payload: { params },
  };
}


export function failedRequest() {
  return {
    type: '@turnoacompanhamento/FAILED_REQUEST',
  };
}


export function successInRequest(
  turnoacompanhamentos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@turnoacompanhamento/SUCCESS_IN_REQUEST',
    payload: { turnoacompanhamentos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(turnoacompanhamento) {
  return {
    type: '@turnoacompanhamento/SUCCESS_REQUEST',
    payload: { turnoacompanhamento },
  };
}

export function successRemove(params) {
  return {
    type: '@turnoacompanhamento/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@turnoacompanhamento/RECORD_FILTERING',
    payload: { params },
  };
}

export function refresh() {
  return {
    type: '@turnoacompanhamento/REFRESH',
  };
}


